<app-header></app-header>
<section *ngIf="!listView" class="middle-section salary-revise">
  <div class="container-fluid">
    <div class="initiale_sestion">
      <div class="head">
        <div class="title-container">
          <i (click)="goToEmpolyeeList()" class="fa-solid fa-angle-left"></i>
          <h4 class="form-title-sm">{{'Salary Revise' | translate}}</h4>
        </div>
        <div class="custom-container">
          <div *ngIf="employeeDetails && employeeDetails.nominie_status==1">
            <button class="btn btn-main2" (click)="goToDependenceList()">{{'Dependence details' | translate}}</button>
          </div>
          <!-- <button *ngIf="accountDetails.current_user == 1 && employeeDetails && employeeDetails.status != 7" id="submit_btn" class="btn btn-main2" data-target="#employeeWithCcpsStage2" data-toggle="modal">{{'Add Salary Revise' | translate}}</button> -->
        </div>
      </div>
    </div>

    <div class="certificate">
      <div class="certificate"
        *ngIf="resignationDetails && resignationDetails.status==7 && employeeDetails && employeeDetails.status==7">
        <div class="certificate-container">
          <a href="{{resignationDetails.termination_pdf}}" target="_blank">
            <div>{{'Termination Certificate' | translate}}</div> <!-- Corrected from "Hiring Certificate" -->
            <div class="pdf-container">
              <div class="pdf_icon"><img src="assets/images/download.png"></div>
            </div>
          </a>
        </div>
      </div>

      <!-- <div class="certificate">
      <div class="certificate-container">
        <a (click)="viewCNSSHiringCertificate()" style="cursor: pointer;">
          <div>{{'CNSS Hiring Certificate' | translate}}</div>
          <div class="pdf-container">
            <div class="pdf_icon"><img src="assets/images/download.png"></div>
          </div>
        </a>
      </div>
    </div>  -->

      <!-- <div class="certificate">
      <div class="certificate-container">
        <a (click)="viewCnamgsHiringCertificate()" style="cursor: pointer;">
          <div>{{'CNAMGS Hiring Certificate' | translate}}</div>
          <div class="pdf-container">
            <div class="pdf_icon"><img src="assets/images/download.png"></div>
          </div>
        </a>
      </div>
    </div> -->
    </div>

    <!-- <div class="certificate" *ngIf="employeeDetails && employeeDetails.status==1">
    <div class="certificate-container" *ngIf="employeeDetails">
      <a href="{{employeeDetails.hiring_certificate}}" target="_blank">
        <div>{{'Hiring Certificate' | translate}}</div>
        <div class="pdf-container">
          <div class="pdf_icon"><img src="assets/images/download.png"></div>
        </div>
      </a>
    </div>
  </div> -->



    <div *ngIf="employeeDetails" class="user-data-container">
      <div class="user-data">
        <!-- <div class="child-container">
          <label class="labeltxt-sm">{{'Employee CCPS ID' | translate}}</label>
          <h6 *ngIf="employeeDetails.ccps_code">{{employeeDetails.ccps_code}}</h6>
          <h6 *ngIf="!employeeDetails.ccps_code">--</h6>
        </div> -->
        <div class="child-container">
          <label class="labeltxt-sm">{{'Name2' | translate}}</label>
          <h6>{{employeeDetails.name}}</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'NIP Number' | translate}}</label>
          <h6>{{employeeDetails.nip_number}}</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'position' | translate}}</label>
          <h6 *ngIf="employeeDetails.designation">{{employeeDetails.designation}}</h6>
          <h6 *ngIf="!employeeDetails.designation">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'CNAMGS ID' | translate}}</label>
          <h6 *ngIf="employeeDetails.cnamgs">{{employeeDetails.cnamgs}}</h6>
          <h6 *ngIf="!employeeDetails.cnamgs">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'CNSS ID' | translate}}</label>
          <h6 *ngIf="employeeDetails.cnss">{{employeeDetails.cnss}}</h6>
          <h6 *ngIf="!employeeDetails.cnss">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'Mobile' | translate}}</label>
          <h6>{{employeeDetails.mobile}}</h6>
          <h6 *ngIf="!employeeDetails.mobile">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'CNSS Status' | translate}}</label>
          <h6 *ngIf="employeeDetails.cnss_status_label">{{employeeDetails.cnss_status_label}}</h6>
          <h6 *ngIf="!employeeDetails.cnss_status_label">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'CNAMGS Status' | translate}}</label>
          <h6 *ngIf="employeeDetails.cnamgs_status_label">{{employeeDetails.cnamgs_status_label}}</h6>
          <h6 *ngIf="!employeeDetails.cnamgs_status_label">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'Employee Status' | translate}}</label>
          <h6 *ngIf="employeeDetails.status_type">{{employeeDetails.status_type}}</h6>
          <h6 *ngIf="!employeeDetails.status_type">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'Join Date' | translate}}</label>
          <h6 *ngIf="employeeDetails.join_date">{{employeeDetails.join_date}}</h6>
          <h6 *ngIf="!employeeDetails.join_date">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'Date of Birth' | translate}}</label>
          <h6 *ngIf="employeeDetails.date_of_birth">{{employeeDetails.date_of_birth}}</h6>
          <h6 *ngIf="!employeeDetails.date_of_birth">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'Email ID' | translate}}</label>
          <h6 *ngIf="employeeDetails.email">{{employeeDetails.email}}</h6>
          <h6 *ngIf="!employeeDetails.email">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'Company Name' | translate}}</label>
          <h6 *ngIf="employeeDetails.company_name">{{employeeDetails.company_name}}</h6>
          <h6 *ngIf="!employeeDetails.company_name">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'Address' | translate}}</label>
          <h6 *ngIf="employeeDetails.address">{{employeeDetails.address}}</h6>
          <h6 *ngIf="!employeeDetails.address">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'Gender' | translate}}</label>
          <h6 *ngIf="employeeDetails.gender">{{employeeDetails.gender}}</h6>
          <h6 *ngIf="!employeeDetails.gender">--</h6>
        </div>
      </div>
    </div>
    <h3 *ngIf="accountDetails.current_user == 1" (click)="view()" id="view">{{'View More' | translate}}</h3>
    <div *ngIf="accountDetails.current_user == 1" class="company_details card_gr answer">
      <div class="head">
        <h5 class="text-md">{{'Employee Details' | translate}}</h5>
      </div>
      <div *ngIf="employeeDetails" class="">
        <div class="first_section">
          <div class="profile-info">
            <div class="parent-container mb-4">
              <!-- NIF Number (common) -->
              <div class="child-container">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'NIF Number' | translate}}&nbsp;:</label></div>
                  <div class="txt-block">
                    <p class="txt-capitalize">{{ employeeDetails?.nif_number || '--' }}</p>
                  </div>
                </div>
              </div>

              <!-- Join Date (common key = joindate in all) -->
              <div class="child-container">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Hiring Date' | translate}}&nbsp;:</label></div>
                  <div class="txt-block">
                    <p>{{ employeeDetails?.joindate || employeeDetails?.join_date || '--' }}</p>
                  </div>
                </div>
              </div>

              <div class="child-container">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Hiring Certificate Date' | translate}}&nbsp;:</label></div>
                  <div class="txt-block"><p>{{ employeeDetails?.hiring_certificate_date || '--' }}</p></div>
                </div>
              </div>

              <!-- Position (exists in entity 1 & 2 & 3) -->
              <div class="child-container">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Occupation / Position' | translate}}&nbsp;:</label></div>
                  <div class="txt-block">
                    <p class="txt-capitalize">{{ employeeDetails?.position || employeeDetails?.designation || '--' }}</p>
                  </div>
                </div>
              </div>

              <!-- Gender (exists in entity 2 & 3) -->
              <div class="child-container" *ngIf="employeeDetails?.gender">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Gender' | translate}}&nbsp;:</label></div>
                  <div class="txt-block">
                    <p>{{ employeeDetails?.gender || '--' }}</p>
                  </div>
                </div>
              </div>

              <!-- ID Proof Type (exists in entity 2 & 3) -->
              <div class="child-container" *ngIf="employeeDetails?.id_type">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'ID Proof Type' | translate}}&nbsp;:</label></div>
                  <div class="txt-block">
                    <p>{{ employeeDetails?.id_type || '--' }}</p>
                  </div>
                </div>
              </div>

              <div class="child-container">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Employee Type' | translate}}&nbsp;:</label></div>
                  <div class="txt-block"><p>{{ employeeDetails?.employee_type || '--' }}</p></div>
                </div>
              </div>

              <div class="child-container">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Type of Contract' | translate}}&nbsp;:</label></div>
                  <div class="txt-block"><p>{{ employeeDetails?.type_of_contract || '--' }}</p></div>
                </div>
              </div>
          
              <div class="child-container">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Contract End Date' | translate}}&nbsp;:</label></div>
                  <div class="txt-block"><p>{{ employeeDetails?.contract_end_date || '--' }}</p></div>
                </div>
              </div>
          
              <div class="child-container">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Professional Rank' | translate}}&nbsp;:</label></div>
                  <div class="txt-block"><p>{{ employeeDetails?.professional_rank || '--' }}</p></div>
                </div>
              </div>

              <div class="child-container">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Nationality' | translate}}&nbsp;:</label></div>
                  <div class="txt-block"><p>{{ employeeDetails?.nationality || '--' }}</p></div>
                </div>
              </div>
          
              
          
              <div class="child-container">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'ID Proof Number' | translate}}&nbsp;:</label></div>
                  <div class="txt-block"><p>{{ employeeDetails?.id_number || '--' }}</p></div>
                </div>
              </div>
          
              <div class="child-container">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'ID Proof Expiry Date' | translate}}&nbsp;:</label></div>
                  <div class="txt-block"><p>{{ employeeDetails?.id_proof_expiry_date || '--' }}</p></div>
                </div>
              </div>
          
              <div class="child-container">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Professional Category' | translate}}&nbsp;:</label></div>
                  <div class="txt-block"><p>{{ employeeDetails?.professional_category || '--' }}</p></div>
                </div>
              </div>

              <div class="child-container" *ngIf="employeeDetails?.professional_category_other">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Professional Category (Other)' | translate}}&nbsp;:</label></div>
                  <div class="txt-block"><p>{{ employeeDetails?.professional_category_other || '--' }}</p></div>
                </div>
              </div>

              <div class="child-container" *ngIf="employeeDetails?.employee_type_other">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Employee Type (Other)' | translate}}&nbsp;:</label></div>
                  <div class="txt-block"><p>{{ employeeDetails?.employee_type_other || '--' }}</p></div>
                </div>
              </div>

              <div class="child-container" *ngIf="employeeDetails?.specialty">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Specialty' | translate}}&nbsp;:</label></div>
                  <div class="txt-block"><p class="txt-capitalize">{{ employeeDetails?.specialty || '--' }}</p></div>
                </div>
              </div>

              

            </div>



          </div>
        </div>
      </div>

      <div class="head">
        <h5 class="text-md">{{'Birth Details' | translate}}</h5>
      </div>


      <div class="first_section">
        <div class="profile-info">
          <div class="parent-container mb-4">
            <!-- Parent Details -->
            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'First name of father' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.first_father_name || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Last name of father' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.last_father_name || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'First name of mother' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.first_mother_name || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Last name of mother' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.last_mother_name || '--' }}</p>
                </div>
              </div>
            </div>

            <!-- Birth Details -->
            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Date of Birth' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.dob || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Birth Region' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.birth_region || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Birth City' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.birth_city || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Birth District' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.birth_district || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Birth Neighborhood' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.birth_neighborhood || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Place of Birth' | translate}}&nbsp;:</label></div>
                <div class="txt-block"><p class="txt-capitalize">{{ employeeDetails?.birthplace || employeeDetails?.birth_place || '--' }}</p></div>
              </div>
            </div>

            <div class="child-container" *ngIf="employeeDetails?.birth_country">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Birth Country' | translate}}&nbsp;:</label></div>
                <div class="txt-block"><p>{{ employeeDetails?.birth_country || '--' }}</p></div>
              </div>
            </div>
        
            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Birth Certificate Number' | translate}}&nbsp;:</label></div>
                <div class="txt-block"><p>{{ employeeDetails?.birth_certificate_number || '--' }}</p></div>
              </div>
            </div>
        
            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Birth Certificate Issue Date' | translate}}&nbsp;:</label></div>
                <div class="txt-block"><p>{{ employeeDetails?.birth_certificate_issue_date || '--' }}</p></div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="head">
        <h5 class="text-md">{{'Location / Contact' | translate}}</h5>
      </div>


      <div class="first_section">
        <div class="profile-info">
          <div class="parent-container mb-4">
            <!-- Location / Contact -->
            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Region' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.region || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'City' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.city || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'District' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.district || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Neighborhood' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.neighborhood || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Email Address' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.email || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Post Box' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.post_box || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Phone Number' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.mobile || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container" *ngIf="employeeDetails?.address">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Address' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.address || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container" *ngIf="employeeDetails?.location || employeeDetails?.details_of_location">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Details of Location' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.location || employeeDetails?.details_of_location || '--' }}</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="head">
        <h5 class="text-md">{{'Marital Details' | translate}}</h5>
      </div>


      <div class="first_section">
        <div class="profile-info">
          <div class="parent-container mb-4">
            <!-- Marital -->
            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Marital Status' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.marital_status || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Marriage Date' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.marriage_date || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container" *ngIf="employeeDetails?.marital_status_other">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Marital Status (Other)' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.marital_status_other || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container" *ngIf="employeeDetails?.maiden_name || employeeDetails?.maiden">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Maiden Name' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.maiden_name || employeeDetails?.maiden || '--' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="head">
        <h5 class="text-md">{{'Public Fund Details' | translate}}</h5>
      </div>


      <div class="first_section">
        <div class="profile-info">
          <div class="parent-container mb-4">
           
            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Administrative Status (Public)' | translate}}&nbsp;:</label>
                </div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.administrative_status_public || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Administration Code' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.administration_code || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Category (Public)' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.category_public || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Employee ID' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.employee_id || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Index' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.index || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Grade' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.grade || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container" *ngIf="employeeDetails?.category">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Category' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.category || '--' }}</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div> -->

      <div class="head">
        <h5 class="text-md">{{'Private Fund Details' | translate}}</h5>
      </div>


      <div class="first_section">
        <div class="profile-info">
          <div class="parent-container mb-4">
            <!-- Private Fund -->
            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Administrative Status (Private)' | translate}}&nbsp;:</label>
                </div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.administrative_status_private || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Employment Start Date' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.employment_start_date || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Nature of Activity' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.nature_of_activity || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Employer Organization ID' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.employer_organization_id || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Employee ID (Employer)' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.employee_id_employer || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Category (Private)' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.category_private || '--' }}</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="head" *ngIf="employeeDetails?.education_level || employeeDetails?.other_qualification">
        <h5 class="text-md">{{'Education Details' | translate}}</h5>
      </div>

      <div class="first_section" *ngIf="employeeDetails?.education_level || employeeDetails?.other_qualification">
        <div class="profile-info">
          <div class="parent-container mb-4">
            <div class="child-container" *ngIf="employeeDetails?.education_level">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Education Level' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p>{{ employeeDetails?.education_level || '--' }}</p>
                </div>
              </div>
            </div>

            <div class="child-container" *ngIf="employeeDetails?.other_qualification">
              <div class="txt-container">
                <div class="label-txt-container"><label>{{'Other Qualification' | translate}}&nbsp;:</label></div>
                <div class="txt-block">
                  <p class="txt-capitalize">{{ employeeDetails?.other_qualification || '--' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    

        




      <div class="head">
        <h5 class="text-md">{{'Employee Documents' | translate}}</h5>
      </div>


      <div class="first_section">
        <div class="profile-info">
          <div class="parent-container mt-4">

            <div class="child-container" *ngIf="employeeDetails?.image_url">
              <div class="card card-detail">
                <a  target="_blank" [href]="employeeDetails?.image_url">
                  <i class="fa fa-download"></i>
                  <label class="labeltxt readfor">{{'Employee Photo' | translate}}</label>
                </a>
              </div>
            </div>

            <div class="child-container" *ngIf="employeeDetails?.id_proof_url">
              <div class="card card-detail">
                <a  target="_blank" [href]="employeeDetails?.id_proof_url">
                  <i class="fa fa-download"></i>
                  <label class="labeltxt readfor">{{'ID Proof' | translate}}</label>
                </a>
              </div>
            </div>

            <div class="child-container" *ngIf="employeeDetails?.employee_birth_certificate_cnamgs_url">
              <div class="card card-detail">
                <a  target="_blank" [href]="employeeDetails?.employee_birth_certificate_cnamgs_url">
                  <i class="fa fa-download"></i>
                  <label class="labeltxt readfor">{{'Birth certificate of employee' | translate}}</label>
                </a>
              </div>
            </div>

            <div class="child-container" *ngIf="employeeDetails?.marriage_certificate_cnamgs_url">
              <div class="card card-detail">
                <a  target="_blank" [href]="employeeDetails?.marriage_certificate_cnamgs_url">
                  <i class="fa fa-download"></i>
                  <label class="labeltxt readfor">{{'Marriage Certificate' | translate}}</label>
                </a>
              </div>
            </div>

            <div class="child-container" *ngIf="employeeDetails?.spouse_birth_certificate_cnamgs_url">
              <div class="card card-detail">
                <a  target="_blank" [href]="employeeDetails?.spouse_birth_certificate_cnamgs_url">
                  <i class="fa fa-download"></i>
                  <label class="labeltxt readfor">{{'Birth certificate of spouse' | translate}}</label>
                </a>
              
              </div>
            </div>

            <div class="child-container" *ngIf="employeeDetails?.payslips_url">
              <div class="card card-detail">
                <a  target="_blank" [href]="employeeDetails?.payslips_url">
                  <i class="fa fa-download"></i>
                  <label class="labeltxt readfor">{{'Payslip (last three months)' | translate}}</label>
                </a>
               
              </div>
            </div>

          </div>
        </div>
      </div>



      <div *ngIf="resignationDetails" class="head">
        <h5 class="text-md">{{'Resignation Details' | translate}}</h5>
      </div>
      <div *ngIf="resignationDetails" class="mb-3">
        <div class="first_section">
          <div class="profile-info resignation">
            <div class="parent-container">
              <div class="child-container">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Reason' | translate}}&nbsp;:</label></div>
                  <div class="txt-block">
                    <p>{{resignationDetails.reason}}</p>
                  </div>
                </div>
              </div>
              <div class="child-container">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Resignation Date' | translate}}&nbsp;:</label></div>
                  <div class="txt-block">
                    <p>{{resignationDetails.resigned_date}}</p>
                  </div>
                </div>
              </div>
              <div *ngIf="resignationDetails.reason_for_other" class="child-container full-width">
                <div class="txt-container">
                  <div class="label-txt-container"><label>{{'Other Reason' | translate}}&nbsp;:</label></div>
                  <div class="txt-block">
                    <p>{{resignationDetails.reason_for_other}}</p>
                  </div>
                </div>
              </div>
              <div *ngIf="resignationDetails?.image" class="child-container">
                <div class="card card-detail"><a target="_blank" href="{{resignationDetails?.image}}"><i
                      class="fa fa-download"></i>
                    <label *ngIf="resignationDetails?.reason == 'Death' || resignationDetails?.reason == 'Décès' "
                      class="labeltxt readfor" for="deathCertificate">{{'Death Certificate' | translate}}</label>
                    <label *ngIf="resignationDetails?.reason != 'Death' && resignationDetails?.reason != 'Décès' "
                      class="labeltxt readfor" for="deathCertificate">{{'Health Certificate' | translate}}</label>
                  </a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="reportTable">
      <table id="tooltip-table" class="quarter_table table-responsive">
        <colgroup>
          <col span="1" class="slno">
          <col span="1" class="date">
          <col span="1" class="designation">
          <col span="1" class="family_allowance">
          <col span="1" class="cnss_salary">
          <col span="1" class="cnamgs_salary">

          <!-- <col span="1" class="salary"> -->
        </colgroup>
        <thead>
          <tr>
            <th scope="col">{{'SL NO' | translate}}</th>
            <th scope="col">{{'Date' | translate}}</th>
            <th scope="col">{{'position' | translate}}</th>
            <th scope="col">{{'Family Allowance' | translate}}</th>
            <th scope="col">{{'CNSS Monthly Salary' | translate}}</th>
            <th scope="col">{{'CNAMGS Monthly Salary' | translate}}</th> 
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let detail of employeeFullDetails; let i = index">
            <td data-label="SL NO">{{i +1}}</td>
            <td data-label="Date">{{detail.date}}</td>
            <td data-label="Designation">{{detail.designation}}</td>
            <td data-label="Family Allowance">{{detail.family_allowance}} FCFA</td>
            <td data-label="CNSS Monthly Salary">{{detail.cnss_salary}} FCFA</td>
            <td data-label="CNAMGS Monthly Salary">{{detail.cnamgs_salary}} FCFA</td>
            <!-- <td data-label="Salary">{{detail.salary}} FCFA</td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
<div class="modal fade" id="employeeWithCcpsStage2" data-backdrop="static" data-keyboard="false" tabindex="-1"
  role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeModal()"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-body">
        <div class="parent-container">
          <h5 class="form-title text-center">{{'Add Employees step3' | translate}}</h5>
          <form id="WithCcpsStage2Form" [formGroup]="employeeSalaryForm" (ngSubmit)="onSubmitSalary()">
            <div class="input-container input-box-white">
              <div class="child-container" [owlDateTimeTrigger]="dt45">
                <label class="labeltxt">{{'Join Date' | translate}}</label>
                <div class="date-field">
                  <input class="" readonly [min]="minDate" [owlDateTime]="dt45" [max]="todayDate" name="join_date"
                    formControlName="join_date">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <div *ngIf="isSubmitted && f.join_date.errors" class="invalid-feedback">
                  <div *ngIf="f.join_date.errors?.required">{{'Join Date'|translate}} {{'is required'|translate}}</div>
                  <div *ngIf="f.join_date.errors?.pattern">{{'Join Date'|translate}} {{'should be valid' | translate}}
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dt45></owl-date-time>
              </div>
              <div class="child-container">
                <label class="labeltxt">{{'position' | translate}}</label>
                <input type="text" name="designation" formControlName="designation">
                <div *ngIf="isSubmitted && f.designation.errors" class="invalid-feedback">
                  <div *ngIf="f.designation.errors?.required">{{'position'|translate}} {{'is required'|translate}}</div>
                  <div *ngIf="f.designation.errors?.pattern">{{'position'|translate}} {{'should be valid' | translate}}
                  </div>
                </div>
              </div>
              <div class="child-container">
                <label class="labeltxt">{{'Gross Monthly Salary' | translate}} (FCFA)</label>
                <input type="text" name="base_salary" formControlName="base_salary" maxlength="20">
                <div class="text-sm textUnderMobile text-center">{{'Salary should be minimum of 10 000 FCFA' |
                  translate}}</div>
                <div *ngIf="isSubmitted && f.base_salary.errors" class="invalid-feedback">
                  <div *ngIf="f.base_salary.errors?.required">{{'Gross Monthly Salary'|translate}} {{'is
                    required'|translate}}</div>
                  <div *ngIf="f.base_salary.errors?.pattern">{{'Gross Monthly Salary'|translate}} {{'should be valid' |
                    translate}}</div>
                  <div *ngIf="f.base_salary.errors?.min">{{'Gross Monthly Salary'|translate}} {{'should be minimum of 10
                    000 FCFA' | translate}}</div>
                </div>
              </div>
              <!--  <div class="child-container">
                <label class="labeltxt">{{'Salary' | translate}}</label>
                <input type="text" name="salary" formControlName="salary">
                <div *ngIf="isSubmitted && f.salary.errors" class="invalid-feedback">
                  <div *ngIf="f.salary.errors?.required">{{'Salary'|translate}} {{'is required'|translate}}</div>
                  <div *ngIf="f.salary.errors?.pattern">{{'Salary'|translate}} {{'should be valid' | translate}}</div>
                </div>
              </div> -->
            </div>
            <button type="submit" id="submit_btn" class="btn btn-medium">{{'Submit' | translate}}</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
<app-contact-floating></app-contact-floating>